import { deselectAllProducts } from '../store/products/deselectAllProducts';
import l10n from '../shared/strings';
import { showDialogAsync } from '../components/dialog';

const strings = l10n.PRODUCTS_BULK_SELECTION.switchSource;

async function confirmSwitchSource() {
  try {
    await showDialogAsync({
      title: strings.title,
      text: strings.text,
      textBtnOk: strings.btnConfirm,
      textBtnCancel: strings.btnCancel,
    }).promise;
    return true;
  } catch {
    return false;
  }
}

export default async function confirmAndClearOtherProductSelectionSource({
  dispatch,
  getState,
  targetSource,
}) {
  const selection = getState().products?.ui?.selection || {};
  const keys = selection.keys || [];
  const { source } = selection;

  if (keys.length === 0 || !source || source === targetSource) {
    return true;
  }

  if (!(await confirmSwitchSource())) return false;
  dispatch(deselectAllProducts());
  return true;
}
